import React from 'react';
import '../../App.css';
import { Container, Box, Divider, Grid, Hidden } from '@material-ui/core';
import { toggleLoginModal } from '../../reducers/UiReducer';
import LoginModal from './LoginModal';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
const Headers = () => {
	const dispatch = useDispatch();
	const history = useHistory();
	return (
		<>
			<Container
				style={{
					paddingLeft: '40px',
					paddingRight: '40px',
					paddingTop: '20px',
				}}>
				<Box
					style={{
						display: 'flex',
						justifyContent: 'space-between',
						alignItems: 'center',
					}}>
					<img
						onClick={() => history.push('/')}
						src='https://www.musafirbazar.com/assets/images/musafirbazarlogo.png'
						style={{ height: '100%', width: 200, cursor: 'pointer' }}
					/>
					{/* <Hidden only={['xs']}>
						<div className='wrap' style={{ width: '35%' }}>
							<div className='search'>
								<input
									type='text'
									className='searchTerm'
									placeholder='Search here...'
								/>
								<button type='submit' className='searchButton'>
									<i class='fa fa-search'></i>
								</button>
							</div>
						</div>
					</Hidden> */}
					<Box
						style={{
							border: '1px solid #d8d8d8',
							borderRadius: '25px',
						}}>
						<Hidden only={['xs']}>
							<span
								className='dropdown'
								style={{ padding: 10, cursor: 'pointer', borderRadius: 12 }}>
								<i class='fa-solid fa-phone dropdown'></i>
								<div className='dropdown-content'>
									<span style={{ fontSize: 14 }}>
										Get help from our experts 24/7
									</span>
									<br />
									<span
										style={{ fontSize: 20, marginTop: 5, fontWeight: 'bold' }}>
										(+91) 8877773388
									</span>{' '}
									<br />
									<Box style={{ alignItems: 'center', marginTop: 5 }}>
										<i className='fa fa-envelope' aria-hidden='true'></i>
										<span style={{ marginLeft: 10 }}>
											info@musafirbazar.com
										</span>
									</Box>
								</div>
							</span>
							<span
								className='dropdown2'
								style={{ padding: 10, cursor: 'pointer', borderRadius: 12 }}>
								<i className='fa-solid fa-user'></i>
								<div className='dropdown2-content'>
									<span style={{ fontSize: 20 }}>Welcome Guest</span>
									<br />
									<Divider style={{ marginTop: 10, marginBottom: 20 }} />
									<button
										onClick={() => dispatch(toggleLoginModal(true))}
										style={{
											fontSize: 16,
											marginTop: 5,
											// fontWeight: 'bold',
											cursor: 'pointer',
										}}>
										Login / SignUp
									</button>{' '}
									<br />
								</div>
							</span>
						</Hidden>
						<span
							className='dropdown2'
							style={{ padding: 10, cursor: 'pointer' }}>
							<i className='fa-solid fa-bars'></i>
							<div className='dropdown2-content'>
								<span style={{ fontSize: 20 }}>Welcome Guest</span>
								<br />
								<Divider style={{ marginTop: 10, marginBottom: 20 }} />
								<span
									style={{
										fontSize: 20,
										marginTop: 5,
										fontWeight: 'bold',
									}}>
									Login / SignUp
								</span>{' '}
								<br />
							</div>
						</span>
					</Box>
				</Box>
			</Container>
			<Hidden only={['xs']}>
				<Container style={{ marginTop: 10, marginBottom: 10 }}>
					<Grid container spacing={2}>
						<Grid item xs={2}></Grid>
						<Grid item xs={8}>
							<Box style={{ display: 'flex', justifyContent: 'space-between' }}>
								<Box className='dropdown3'>
									<span style={{ fontWeight: 'bold', cursor: 'pointer' }}>
										Destinations
									</span>
									<div className='dropdown3-content'>
										<Box
											style={{
												display: 'flex',
												justifyContent: 'space-between',
											}}>
											<Box>
												<span style={{ color: 'darkblue' }}>INDIA</span>
												<br />
												<Divider style={{ marginTop: 10 }} />
												<Box>
													<span
														style={{
															// marginTop: 5,
															fontSize: 14,
														}}>
														East & North East India
													</span>
												</Box>
												<Box>
													<span
														style={{
															// marginTop: 5,
															fontSize: 14,
														}}>
														East & North East India
													</span>
												</Box>
												<Box>
													<span
														style={{
															// marginTop: 5,
															fontSize: 14,
														}}>
														East & North East India
													</span>
												</Box>
												<Box>
													<span
														style={{
															// marginTop: 5,
															fontSize: 14,
														}}>
														East & North East India
													</span>
												</Box>
												<br />
												{/* <br /> */}
												<span style={{ color: 'darkblue' }}>INTERNATIONAL</span>
												<br />
												<Divider style={{ marginTop: 10 }} />
												<span
													style={{
														marginTop: 5,
														fontSize: 14,
													}}>
													East & North East India
												</span>{' '}
												<br />
												{/* <br /> */}
												<span
													style={{
														fontSize: 14,
													}}>
													West & Central India
												</span>{' '}
												<br />
												{/* <br /> */}
												<span
													style={{
														fontSize: 14,
													}}>
													West & Central India
												</span>{' '}
												<br />
												{/* <br /> */}
												<span
													style={{
														fontSize: 14,
													}}>
													West & Central India
												</span>{' '}
											</Box>
											<Box
												style={
													{
														// display: 'flex',
														// justifyContent: 'space-between',
													}
												}>
												<span style={{ color: 'grey' }}>States</span>
												<br />
												<span style={{ fontWeight: 'bold', fontSize: 12 }}>
													Arunachal Pradesh
												</span>
												<br />
												<span style={{ fontWeight: 'bold', fontSize: 12 }}>
													Meghalaya
												</span>
												<br />
												<span style={{ fontWeight: 'bold', fontSize: 12 }}>
													Mizoram
												</span>
												<br />
												<span style={{ fontWeight: 'bold', fontSize: 12 }}>
													Nagaland
												</span>
												<br />
												<span style={{ fontWeight: 'bold', fontSize: 12 }}>
													West Bengal
												</span>

												{/* <Box>
												<span style={{ color: 'grey' }}>Trending Cities</span>
											</Box> */}
											</Box>
											<Box
												style={{
													display: 'flex',
													// justifyContent: 'space-between',
												}}>
												<span style={{ color: 'grey' }}>Trending Cities</span>
												{/* <Box>
												<span style={{ color: 'grey' }}>Trending Cities</span>
											</Box> */}
											</Box>
										</Box>
									</div>
								</Box>
								<Box style={{}}>
									<span>Special Tours</span>
								</Box>
								<Box style={{}}>
									<span>Special Tours</span>
								</Box>
								<Box style={{}}>
									<span>Special Tours</span>
								</Box>
								<Box style={{}}>
									<span>Special Tours</span>
								</Box>
							</Box>
						</Grid>
						<Grid item xs={2}></Grid>
					</Grid>
				</Container>
			</Hidden>
			<LoginModal />
		</>
	);
};

export default Headers;
